var map = {
	"./theme-a.png": "a617",
	"./theme-b.png": "e8ab",
	"./theme-c.png": "6da8e",
	"./theme-d.png": "8f5a",
	"./theme-e.png": "6c78",
	"./theme-f.png": "fdfe",
	"./theme-g.png": "a90d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7866";